<template>
    <AdminTableActionMenu
      v-if="menu === 'admin'"
      :bulb="bulb"
      :playlist="playlist"
      :data-bulb-id="dataBulbId"
      :data-parent-node-id="dataParentNodeId"
      :disabled="disabled"
      :icon="icon"
      :thumbnail="thumbnail"
      :handlePopoverShow="handlePopoverShow">
    </AdminTableActionMenu>
    <PlaylistPremadeActionMenu
      v-else-if="menu === 'premade'"
      :playlist="playlist"
      :actionColumn="actionColumn">
    </PlaylistPremadeActionMenu>
    <PlaylistTableActionMenu
      v-else-if="menu === 'playlist'"
      :playlist="playlist"
      :actionColumn="actionColumn"
      :handlePopoverShow="handlePopoverShow">
    </PlaylistTableActionMenu>
</template>

<script>
import AdminTableActionMenu from './snippets/AdminTableActionMenu';
import PlaylistPremadeActionMenu from './snippets/PlaylistPremadeActionMenu';
import PlaylistTableActionMenu from './snippets/PlaylistTableActionMenu';

export default {
  name: 'ActionMenu',
  components: {
    AdminTableActionMenu,
    PlaylistPremadeActionMenu,
    PlaylistTableActionMenu,
  },
  props: [
    'actionColumn',
    'bulb',
    'data-bulb-id',
    'data-parent-node-id',
    'disabled',
    'handlePopoverShow',
    'icon',
    'menu',
    'playlist',
    'thumbnail',
  ],
};
</script>
